routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.blogDetail', {
      url: "blogDetail/{blogSlug}",
      template: `<blog-detail sh-ctrl="shCtrl"></blog-detail>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/blog/blog-detail/blog-detail.config.js
 **/